import { createClient } from "@/shared/urql/urql";
import {
  RegisterExistingCustomerDocument,
  type RegisterExistingCustomerInput,
} from "@/shared/generated/graphql";
import { handleCombinedError } from "@/shared/helper/handleCombinedError.helper";
import { handleErrors } from "@/shared/helper/handleErrors.helper";

export const registerMobilityUser = async (
  registrationData: RegisterExistingCustomerInput,
) => {
  const urqlClient = createClient();

  const { error, data } = await urqlClient
    .mutation(RegisterExistingCustomerDocument, { registrationData })
    .toPromise();
  const errors = data?.registerExistingCustomer?.errors;
  if (error) throw handleCombinedError(error);
  if (errors && errors.length > 0) throw handleErrors(errors);

  return data?.registerExistingCustomer?.caseNumber || undefined;
};
